import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { variant } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';

const modeStyles = variant({
  prop: "mode",
  variants: {
    middle: {
      whiteSpace: "nowrap"
    }
  }
});
const Truncate = styled(Box)`
    display: inline-flex;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    ${modeStyles};
`;

export { Truncate };
//# sourceMappingURL=Truncate.styled.es.js.map
